// extracted by mini-css-extract-plugin
export default {"news":"NewsInfo_news__AQg0q"};